import { useEffect } from "react"
import { EditInput } from "@/components"
import {
  currentUserResponseToUser,
  useUpdateUserApi,
  UpdateUserRequest,
} from "@/hooks/api"
import { useToast } from "@/hooks"
import { useStore } from "@/store"
import { getUserFacingApiErrorMessage } from "@/lib/apiErrors"
import { useTranslation } from "react-i18next"

interface UserNameInputProps {
  name: string
}

const UserNameInput = ({ name }: UserNameInputProps) => {
  const { alertToast } = useToast()
  const { t } = useTranslation()
  const {
    error: updateUserError,
    data: updateUserResp,
    fetchFn: updateUser,
  } = useUpdateUserApi()
  const setUserMe = useStore((state) => state.setUserMe)

  useEffect(() => {
    if (!updateUserResp || !updateUserResp.data) return
    setUserMe(currentUserResponseToUser(updateUserResp.data))
  }, [updateUserResp, setUserMe])

  useEffect(() => {
    if (!updateUserError) return
    console.error("Failed to update user name", updateUserError)

    alertToast({
      title: "Failed to update user name",
      description: getUserFacingApiErrorMessage(
        updateUserError,
        t,
        updateUserResp?.message || "Failed to update user name"
      ),
    })
  }, [updateUserError, updateUserResp, alertToast, t])

  const handleSubmit = (value: string) => {
    if (value === name) return

    const payload: UpdateUserRequest = { new_name: value }
    updateUser({ jsonBody: payload })
  }

  return (
    <EditInput
      className="flex-wrap space-y-1 justify-end"
      value={name}
      onSave={handleSubmit}
    />
  )
}

export default UserNameInput
